/**
 * Expander Box
 **/
export const ExpanderBox = function( $ ) {

	const module = {

		elements: {
			$expanderBox: $( '.expander-box' ),
		},

		open: function( $box ) {

			/**
			 * Replace the plus icon with a minus.
			 */
			$box.find( '[data-fa-i2svg]' ).removeClass( 'fa-plus' );
			$box.find( '[data-fa-i2svg]' ).addClass( 'fa-minus' );

			/**
			 * Open the box.
			 */
			$box.addClass( 'is-open' );

		},

		close: function( $box ) {

			/**
			 * Replace the minus icon with a plus.
			 */
			$box.find( '[data-fa-i2svg]' ).removeClass( 'fa-minus' );
			$box.find( '[data-fa-i2svg]' ).addClass( 'fa-plus' );

			/**
			 * Close the box.
			 */
			$box.removeClass( 'is-open' );

		},

	};

	module.elements.$expanderBox.each( function() {
		const $box       = $( this ),
		      $boxToggle = $( this ).find( '.expander-box-toggle a' );

		$boxToggle.click( function( e ) {
			e.preventDefault();

			if ( $box.hasClass( 'is-open' ) ) {
				module.close( $box );
			} else {
				module.open( $box );
			}

		} );
	} );

	return module;

}( jQuery );
